import { Box, styled, Typography } from '@mui/material';

export const FeedbackContainer = styled(Box)(() => ({
  '& > div': {
    marginBottom: '20px',
  },
}));

export const BoxStyled = styled(Box)(({ theme }) => ({
  padding: '16px 24px 0 24px',
  borderRadius: '5px',
  backgroundColor: theme.palette.colors.selectedAndDetailBackground,
  marginTop: '34px',

  [theme.breakpoints.down('lg')]: {
    marginTop: '24px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '12px',
  },
}));

export const TypographyTitleStyled = styled(Typography)(({ theme }) => ({
  width: '200px',
  margin: '0 38px 3px 0',
  fontSize: '16px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const TypographySubtitleStyled = styled(Typography)(({ theme }) => ({
  margin: '3px 0px 18px 0',
  fontSize: '12px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.variantOnPrimaryBackground,
}));

export const TypographyTextStyled = styled(Typography)(({ theme }) => ({
  margin: '3px 0 2px 8px',
  fontSize: '12px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));
